module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.1c2bfaa8.jpg";